import page from "page";

export default function (ctx) {
    
    if (!ctx.session.sessionKey) {
        page("/login");
    } else {
        page("/dashboard");
    }
}